module.exports = __webpack_public_path__ + "public/images/welcome-collage.ad4e73ea6191d7606e6a610aa7721a49.png";